import { useQuery } from "@tanstack/react-query";

import { fetchSubscriptions } from "@/auth/fetch-subscriptions";
import { env } from "@/env/env";

export const useSubscription = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["subscriptions"],
    queryFn: fetchSubscriptions,
    staleTime: Infinity,
  });

  const subscriptions = data?.subscriptions ?? [];

  // When the API is unreachable (local dev without backend), fall through to
  // hasAdc=true so developers can work on the UI without a running backend.
  const hasAdc =
    isError ||
    subscriptions.some(
      ({ dataSet }) => dataSet?.dataApiDataSetName === env().ADC_DATA_SET
    );

  const hasOnlyAdc = isError || (subscriptions.length === 1 && hasAdc);

  return { hasAdc, hasOnlyAdc, isLoading };
};
